import React from 'react';
import renderIf from '../../../pkgs/render_if';

import {
    FormControl,
    HelpBlock,
} from 'react-bootstrap';
import { strict } from 'assert';

export default class CharField extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            errors: false,
            touched_and_blank: false,
            value: '',
            class_names: '',
            minute: '00',
            hour: '00',
        }
    }

    componentDidMount = () => {
        //console.log('CharField componentDidMount');
        if (this.props.editingInstance[this.props.field_id]) {
            this.setState({value: this.convert_from_military_time(this.props.editingInstance[this.props.field_id])});
        }
        if (this.props.focus === this.props.field_id) {
            //console.log(this.props.field_id + ': focused')
            $(`#${this.props.field_id}`).focus();
        }
    }

    convert_from_military_time = (value) => {

        let hour = value.split(':')[0]
        let minute = value.split(':')[1]
        let am_pm = 'AM';
        // hour must be less than 13 and am_pm == 'p'
        let military_hours = {
            '12': '12',
            '13': '1',
            '14': '2',
            '15': '3',
            '16': '4',
            '17': '5',
            '18': '6',
            '19': '7',
            '20': '8',
            '21': '9',
            '22': '10',
            '23': '11',
        }

        if (Number(hour) > 11) {
            hour = military_hours[String(hour)];
            am_pm = 'PM'
        } else if ( Number(hour) === 0) {
            hour = 12;
        }
        return hour + ':' + minute + ' ' + am_pm
    }

    convert_to_military_time = () => {
        let hour = this.state.hour;
        let minute = this.state.minute;

        // console.log('convert_to_military_time hour');
        // console.log(hour);
        // console.log('convert_to_military_time minute');
        // console.log(minute);
        // console.log('convert_to_military_time this.state.value.toLowerCase().includes(p)');
        // console.log(this.state.value.toLowerCase().includes('p'))
        if (this.state.value.toLowerCase().includes('p')) {
            let military_hours = {
                '1': '13',
                '2': '14',
                '3': '15',
                '4': '16',
                '5': '17',
                '6': '18',
                '7': '19',
                '8': '20',
                '9': '21',
                '10': '22',
                '11': '23',
                '12': '12',
            }
            hour = military_hours[String(hour)];
        } else if (String(hour) === '12') {
            hour = '00';
        } 
        return hour + ':' + minute + ':00'
    }

    is_time_valid = (time_with_no_letters, hour, min) => {
        let validity = false;
        let hr = Number(hour)
        // console.log('hour from is_time_valid: ');
        // console.log(hr)
        // console.log('time_with_no_letters from is_time_valid: ');
        // console.log(time_with_no_letters);
        // console.log('time_with_no_letters.length from is_time_valid: ');
        // console.log(time_with_no_letters.length);
        if (time_with_no_letters.length <= 4 && hr > 0) {
            // console.log('** time_with_no_letters.length from is_time_valid: ');
            // console.log(time_with_no_letters.length);
            if (hr < 25) {
                // console.log('Hour is less than 25');
                // console.log('min from is_time_valid');
                // console.log(min);
                if (min != undefined) {
                    if (min == '00' || min == '15' || min == '30' || min == '45') {
                        validity = true
                    }
                } else {
                    validity = true
                }
            }
        }
        return validity
    }

    get_time_with_no_letters = (value) => {
        // console.log('get_time_with_no_letters value');
        // console.log(value);
        if (typeof(value) == 'string') {
            let first_char = value.charAt(0);

            if (first_char == '0') {
                //console.log('first_char == 0');
                value = value.replace(/^0/,'');
            }

            let formatted_value = value.replace(' ', '').replace(':', '').replace('m', '');

            let time_with_no_letters = formatted_value.replace(/\D/g,'')

            return time_with_no_letters
        }
    }

    get_minute = (value) => {
        // console.log('get minute hour value')
        // console.log(this.get_hour(value))
        let minute = undefined;
        let time_with_no_letters = this.get_time_with_no_letters(value);
        // console.log('get minute time with no letters');
        // console.log(time_with_no_letters)
        let hour = this.get_hour(time_with_no_letters);
        // console.log('get minute hour')
        // console.log(hour)
        // console.log('get minute String(time_with_no_letters).split(this.get_hour(value))')
        // console.log(String(time_with_no_letters).split(this.get_hour(value)))
        if (typeof(value) == 'string') {
            if (time_with_no_letters.length == 3 && String(time_with_no_letters).split(this.get_hour(value))[0] == String(time_with_no_letters).split(this.get_hour(value))[1]) {
                // the first character and the second character are the same like 330, which will cause an error.
                minute = time_with_no_letters.substr(1);
                // console.log('Here is the minute !!! !!! !!! !!! !!!');
                // console.log(minute);
            } else if (hour == 5 && time_with_no_letters.length == 3) {
                minute = time_with_no_letters.substr(1)
            }else {
                // console.log('get_minute hour value is a string: ' + String(this.get_hour(value)));
                minute = String(time_with_no_letters).split(this.get_hour(value))[1];
                // console.log('Here is the minute !!! !!! !!! !!! !!!');
                // console.log(minute);
            }
            this.setState({minute})
        }
        // console.log('get_minute value: ');
        // console.log(value);
        return minute

    }

    get_hour = (value) => {
        
        let time_with_no_letters = this.get_time_with_no_letters(value)

        let first_char = time_with_no_letters.charAt(0)
        // console.log('get_hour first_char: ');
        // console.log(first_char)
        let second_char = time_with_no_letters.charAt(1)
        // console.log('get_hour second_char: ');
        // console.log(second_char)
        let hour, minute;

        if (first_char == '1') {
            //console.log('first_char == 1');
            if (second_char == '0' && time_with_no_letters.length > 3) {
                hour = '10'
            } else if (second_char == '1' && time_with_no_letters.length > 3) {
                // This could be 115p
                if (time_with_no_letters.length > 3){
                   hour = '11'
                }
            } else if (second_char == '2') {
                hour = '12';
            } else {
               hour = first_char
            }
        } else if (first_char == '2' && time_with_no_letters.length == 4) {
            //console.log('military time');
            // Its military time!!!
            hour = first_char + second_char;
        } else if (first_char == '2' && time_with_no_letters.length == 3) {
            // Hour is 2 and its not military time.
            hour = first_char;
        } else {
            hour = first_char;
        }

        //console.log('Hour: ' + String(hour));
        this.setState({hour})
        return hour
    }

    onChange = (time_string) => {
        if (this.setErrorTimer) {
            clearTimeout(this.setErrorTimer);
        }
        let value = String(time_string.target.value);
        this.setState({value, errors: false, class_names: ''})
        // console.log('onChange value');
        // console.log(value)
        let time_with_no_letters = this.get_time_with_no_letters(value);
        // console.log('time_with_no_letters from onChange');
        // console.log(time_with_no_letters);
        // console.log('minute from onChange');
        let minute =  this.get_minute(value);
        //console.log(minute)
        let time_is_valid = this.is_time_valid(time_with_no_letters, this.get_hour(value), minute);
        this.setErrorTimer = setTimeout(() => {
          if (time_is_valid == false) {
            this.setState({
                errors: true,
                class_names: 'error',
            });
          } else if (time_is_valid == true && minute != undefined) {
              this.props.onSelectChange(this.props.field_id, this.convert_to_military_time());
          }
        }, 750);
    }

    render() {
        return (
            <div>
                <div>
                    <FormControl
                        type='text'
                        value={this.state.value}
                        id={`${this.props.field_id}`}
                        onChange={this.onChange}
                        placeholder={this.props.placeholder}
                    />
                </div>
                <div>
                  {renderIf(this.state.errors === true)(
                    <HelpBlock style={{color: 'red'}}>Hour must be 24 or less and minutes must be 00, 15, 30 or 45. For example, for 9:30 AM type 930a or 9:30am or 09:30 AM.</HelpBlock>
                  )}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/helpers/field/char_parsed_time_field.js